<template>
  <div class="payment-mask"
       v-if="showPayment&&show">
    <div class="mask-empty"></div>
    <div class="payment-title">
      <span>{{paymentTitle}}</span>
      <img @click="handleHidePayMask" class="left-icon-wrap" src="~@/assets/img/app/member/icon_close_no.png">
    </div>
    <div class="payment-input">
      <van-password-input v-model="password" :gutter="7">
      </van-password-input>
      <div class="verification-msg">
        <!-- <p @click="handleToast">没收到验证码?</p> -->
        <span class="again-send"
              v-if="showCode"
              @click="handleCountDown">重新获取</span>
        <span v-else>重新获取 {{second}}s</span>
      </div>
    </div>
    <van-number-keyboard class="number-keyboard"
                         :show="true"
                         theme="custom"
                         close-button-text="完成"
                         @input="handlePayment"
                         @delete="handleDeletePwd"
                         @close="handleSubmitPwd">
    </van-number-keyboard>
  </div>

</template>

<script>
export default {
  name: 'paymentMask',
  props: {
    showPayment: {
      type: Boolean,
      default: false
    },
    showPayment1: {
      type: Boolean,
      default: false
    },
    paymentTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      password: '', // 密码
      showCode: true, // 倒计时和发送短信验证码
      second: '', // 秒
      show: false,
      timer: null
    }
  },
  mounted () {
    // this.handleCountDown()
  },
  methods: {
    handleToast () {
      this.$toast('请检查您是否设置了短信黑名单或稍等片刻后重新点击发送。')
    },
    // 关闭遮罩
    handleHidePayMask () {
      this.password = ''
      this.$emit('update:showPayment1', false)
      this.data = false
    },
    // 倒计时
    handleCountDown () {
      this.showCode = false
      this.second = 60
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(() => {
        this.second--
        if (this.second === 0) {
          clearInterval(this.timer)
          this.showCode = true
        }
      }, 1000)
      this.$emit('handleAgainSend')
    },
    // 设置支付密码
    handlePayment (key) {
      this.password = (this.password + key).slice(0, 6)
      if (this.password.length >= 6) {
        this.handleSubmitPwd()
      }
    },
    // 删除密码
    handleDeletePwd () {
      this.password = this.password.slice(0, this.password.length - 1)
    },
    // 点击完成
    handleSubmitPwd () {
      this.$emit('handleSubmitPwd', this.password)
      this.password = ''
    }
  }
}
</script>

<style lang="less">
.payment-mask {
  border-top-left-radius: 0.32rem;
  .van-password-input__security li{
    background: #d8d8d800;
    border: 1px solid #CCCCCC;
    border-radius: 0.08rem;
  }
  .mask-empty {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }
  .payment-title {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 6.9rem;
    left: 0;
    z-index: 100;
    width: 7.5rem;
    height: 1.98rem;
    border-bottom: 1px solid #e6e6e6;
    background-color: #ffffff;
    animation: title 0.5s;
    border-top-left-radius: 0.32rem;
    border-top-right-radius: 0.32rem;
    .left-icon-wrap {
      width: 0.3rem;
      height: 0.3rem;
      margin: 0.32rem 0.32rem 0 0;
    }
    span:nth-child(1) {
      flex: 1;
      font-size: 0.48rem;
      color: #333333;
      font-weight: 500;
      margin: 0.64rem 0 0 0.64rem;
    }
    .forget-password {
      padding-right: 0.3rem;
      font-size: 0.28rem;
      color: #333;
    }
  }
  .payment-input {
    width: 7.5rem;
    height: 3rem;
    background-color: #fff;
    position: fixed;
    bottom: 4.0rem;
    left: 0;
    z-index: 100;
    animation: input 0.5s;
    .van-password-input {
      margin: 0 0.64rem;
    }
    .verification-msg {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.56rem 0.3rem 0;
      font-size: 0.28rem;
      color: #888;
      p {
        flex: auto;
      }
      .again-send {
        color: #275BF5;
      }
    }
  }
  .number-keyboard {
    .van-number-keyboard__sidebar {
      i:last-child {
        background-color: #ffffff;
        color: #3e3e3e;
      }
    }
    .van-key--green::after {
      border-color: #e5e5e5;
    }
    .van-number-keyboard__sidebar .van-key__wrapper .van-key--blue {
      background-color: #fff;
      color: #1E1F20;
      font-size: 0.36rem;
      font-weight: 500;
    }
  }
}
</style>
